module.exports = __webpack_public_path__ + "img/fleche.37ddaa1.svg";